import {connect} from 'react-redux';

import Airport from './Airport';

const AirportList = ({airports}) => (
    <ul className="taf">
        {airports.map(airport => <Airport {...airport} key={airport.icao} />)}
    </ul>
);

const mapStateToProps = ({airports}) => ({airports});

export default connect(mapStateToProps)(AirportList);
